import { showErrorResponse } from "../../app/utils/common/Functions";
import { showSuccessToast } from "../../app/utils/common/Toast";
import {
    createEmployee,
    deleteEmployee,
    getEmployeeDirectoryAPI,
    getEmployeesAPI,
    updateAttendanceCodeAPI,
    updateEmployee,
    updateEmployeeCodeAPI,
} from "../Apis/employeeApi";

export const employeeReducer = (builder) => {
    builder
        .addCase(getEmployeesAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(getEmployeesAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.pagination = action.payload.data.pagination
            state.employees = action.payload.data.userData;
            state.isDataUpdated = false;
        })
        .addCase(getEmployeesAPI.rejected, (state, action) => {
            showErrorResponse(action.payload);
        })
        .addCase(getEmployeeDirectoryAPI.pending, (state) => {
            state.directoryLoading = true;
        })
        .addCase(getEmployeeDirectoryAPI.fulfilled, (state, action) => {
            state.directoryLoading = false;
            state.directoryUsers = action.payload?.data?.users ?? [];
        })
        .addCase(getEmployeeDirectoryAPI.rejected, (state, action) => {
            state.directoryLoading = false;
            state.directoryUsers = [];
            showErrorResponse(action.payload);
        })
        .addCase(createEmployee.pending, (state) => {
            state.loading = true;

        })
        .addCase(createEmployee.fulfilled, (state, action) => {
            state.loading = false;
            state.isDataUpdated = true;
            showSuccessToast("User created successfully")
        })
        .addCase(createEmployee.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(updateEmployee.pending, (state) => {
            state.loading = true;

        })
        .addCase(updateEmployee.fulfilled, (state, action) => {
            state.loading = false;
            state.isDataUpdated = true;
            showSuccessToast("User update successfully")
        })
        .addCase(updateEmployee.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(deleteEmployee.pending, (state) => {
            state.loading = true;
        })
        .addCase(deleteEmployee.fulfilled, (state, action) => {
            state.loading = false;
            state.isDataUpdated = true;
            state.pagination = {
                ...state.pagination,
                totalData: Math.max(0, Number(state.pagination?.totalData || 0) - 1)
            };
            showSuccessToast(action.payload?.message || "User deleted successfully");
        })
        .addCase(deleteEmployee.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(updateAttendanceCodeAPI.pending, (state) => {
            state.loading = true;
        })
        .addCase(updateAttendanceCodeAPI.fulfilled, (state) => {
            state.loading = false;
            state.isDataUpdated = true;
            showSuccessToast("Attendance code updated successfully");
        })
        .addCase(updateAttendanceCodeAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(updateEmployeeCodeAPI.pending, (state) => {
            state.loading = true;
        })
        .addCase(updateEmployeeCodeAPI.fulfilled, (state) => {
            state.loading = false;
            state.isDataUpdated = true;
            showSuccessToast("Employee code updated successfully");
        })
        .addCase(updateEmployeeCodeAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        });

};
